import { PresetValueProps } from "shared/models/tts";

export const presetBreakValues: PresetValueProps[] = [
  { label: "x-weak", value: "200ms" },
  { label: "weak", value: "500ms" },
  { label: "medium", value: "1000ms" },
  { label: "strong", value: "1500ms" },
  { label: "x-strong", value: "2000ms" },
];

export const presetPitchValues: PresetValueProps[] = [
  { label: "x-low", value: "-4st" },
  { label: "low", value: "-2st" },
  { label: "default", value: "0st" },
  { label: "high", value: "2st" },
  { label: "x-high", value: "4st" },
];

export const presetRateValues: PresetValueProps[] = [
  { label: "x-slow", value: "80%" },
  { label: "slow", value: "90%" },
  { label: "default", value: "100%" },
  { label: "fast", value: "110%" },
  { label: "x-fast", value: "120%" },
];
